import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import { useInView } from "react-intersection-observer";
import PageFilterBar from "../PageFilterBar";
import Ticket from "./Ticket";
import {
  StyledContainer,
  StyledEmptyContainer,
  StyledListContainer,
  StyledLoaderContainer,
  StyledTicket,
} from "./styled";
import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";

const TicketsList: FC = () => {
  const { tableData, loading } = useCustomerTicketsPage();
  const tickets = tableData.data;
  const { ref } = useInView({
    triggerOnce: true,
    onChange: (inView) => {
      if (tableData.hasNextPage && inView && !loading) {
        tableData.fetchNextPage();
      }
    },
  });

  return (
    <StyledContainer>
      <PageFilterBar />
      <StyledListContainer>
        {loading && (
          <StyledLoaderContainer>
            <CircularProgress />
          </StyledLoaderContainer>
        )}

        {!loading &&
          tickets.length > 0 &&
          tickets.map((ticket, index) => {
            const isLastItem = index === tickets.length - 1;

            return (
              <StyledTicket ref={isLastItem ? ref : null} key={ticket.id}>
                <Ticket ticket={ticket} />
              </StyledTicket>
            );
          })}

        {!loading && !tableData.isFetchingNextPage && tickets.length === 0 && (
          <StyledEmptyContainer>
            <Typography variant="bodyMRegular">No Results Found</Typography>
          </StyledEmptyContainer>
        )}

        {tableData.isFetchingNextPage && (
          <StyledLoaderContainer>
            <CircularProgress />
          </StyledLoaderContainer>
        )}
      </StyledListContainer>
    </StyledContainer>
  );
};

export default TicketsList;
